import { OidcClientService } from '@upmc-healthplan-npm/oidc-client';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {
  constructor(private auth: OidcClientService) {

  }

  public setupUserStore(issuer: string, acr: string, audience: string) {
    this.auth.setClientId(audience);
    this.auth.setAuthority(issuer + '.well-known/openid-configuration?p=' + acr);
    sessionStorage.setItem('authority', this.auth.userManager.settings.authority);
    sessionStorage.setItem('client_id', this.auth.userManager.settings.client_id);
  }

  public shouldRenewToken() {
    return this.auth.isExpiring() && !this.auth.isExpired();
  }
}
